<template>
  <div>
    <div id="loading-wrapper" ref="loadingWrapper">
			<div class="spinner">
				<div class="line1"></div>
				<div class="line2"></div>
				<div class="line3"></div>
				<div class="line4"></div>
				<div class="line5"></div>
				<div class="line6"></div>
			</div>
		</div>
    <card>
      <div slot="header">
        <h4 class="card-title">Administración de tirajes</h4>
        <p class="category text-muted">Administre listado de tirajes</p>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <button class="btn btn-primary btn-fill pull-right" @click="handleAdd">
            <i class="fa fa-plus"></i> Agregar tiraje
          </button>
        </div>
        <div class="col-sm-12">
          <el-table class="table-striped" :data="tableData">
            <el-table-column type="index" width="80"></el-table-column>
            <el-table-column prop="description" label="Descripción"></el-table-column>
            <el-table-column prop="book" label="Libro"></el-table-column>
            <el-table-column prop="date" label="Fecha"></el-table-column>
            <el-table-column prop="quantity" label="Cantidad" align="right"></el-table-column>
            <el-table-column prop="total" label="Costo total($)" align="right"></el-table-column>
            <el-table-column label="Opciones">
              <div class="td-actions" slot-scope="props">
                <a v-tooltip.top-center="'Editar'" class="btn btn-warning btn-link btn-lg btn-grid"
                  @click="handleEdit(props.$index, props.row)">
                  <i class="fa fa-edit"></i>
                </a>
                <a v-tooltip.top-center="'Eliminar'" class="btn btn-danger btn-link btn-lg btn-grid"
                  @click="showSwal('delete', props.row)">
                  <i class="fa fa-close"></i>
                </a>
              </div>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </card>
  </div>
</template>
<script>
  import {Dialog, Table, TableColumn} from 'element-ui'
  import Swal from 'sweetalert2'
  import axios from "axios";

  export default{
    components: {
      [Dialog.name]: Dialog,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn
    },
    data () {
      return {
        tableData: [],
        modals: {
          basic: false,
          centered: false,
          custom: false,
          confirm: false
        }
      }
    },
    mounted () {
      this.$checkToken();
      this.fetchDataFromAPI();
    },
    methods: {
      showSwal (type, row) {
        if (type === 'delete') {
          Swal.fire({
            title: this.$systemVariables.deleteRecordTitle,
            text: this.$systemVariables.deleteRecordIrreversible,
            showCancelButton: true,
            confirmButtonClass: 'btn btn-success btn-fill',
            cancelButtonClass: 'btn btn-danger btn-fill',
            confirmButtonText: this.$systemVariables.yesDeleteIt,
            cancelButtonText: this.$systemVariables.cancel,
            buttonsStyling: false
          }).then((result) => {
              if (result.isConfirmed) {
                // actually delete the record
                axios.delete(this.$systemVariables.apiUrl + 'runs/' + row.code, {
                  'headers': { 'Authorization': JSON.parse(localStorage.getItem('jwt')).value }
                })
                .then((response) => {
                  Swal.fire({
                    title: this.$systemVariables.recordDeletedSuccessfully,
                    html: "",
                    icon: "success"
                  })
                  .then(() => {
                    this.fetchDataFromAPI();
                  });
                })
                .catch((error) => {
                  // console.error('Error al eliminar los datos:', error);
                });
              } else{
                // do nothing
              }
            });
        }
      },
      handleEdit (index, row) {
        this.$router.push({
          name: 'Detalle de tiraje',
          params: { 
            code: row.code,
            description: row.description,
            codbook: row.codbook,
            quantity: row.quantity,
            cost: row.cost,
            date: row.date,
            editorialpercentage: row.editorial_percentage,
            authorpercentage: row.author_percentage,
            books: this.booksList
          }
        });
      },
      handleAdd () {
        this.$router.push({
          name: 'Detalle de tiraje',
          params: { 
            code: '',
            description: '',
            codbook: '',
            quantity: 0,
            cost: 0.0,
            date: 0.0,
            editorialpercentage: 0.0,
            authorpercentage: 0.0,
            books: this.booksList
          }
        });
      },
      async fetchDataFromAPI() {
        let wrapper = this.$refs.loadingWrapper;
        wrapper.style.display = 'block';

        axios.get(this.$systemVariables.apiUrl + 'books?perPage=500&forSelect=1&rand=' + Math.random().toString(), {
            'headers': { 'Authorization': JSON.parse(localStorage.getItem('jwt')).value }
          })
          .then((response) => {
            this.booksList = response.data.message;
          });

        return axios.get(this.$systemVariables.apiUrl + 'runs?perPage=500&rand=' + Math.random().toString(), {
            'headers': { 'Authorization': JSON.parse(localStorage.getItem('jwt')).value }
          })
          .then((response) => {
            this.tableData = response.data.message.data;
            wrapper.style.display = 'none';
          })
          .catch((error) => {
            //console.error('Error al cargar los datos:', error);
            wrapper.style.display = 'none';
          });
      },
    }
  }
</script>
<style>
</style>
